export const PatientSidebarItemKeys = {
  Chat: 'chat',
  Notes: 'notes',
  LiveCalls: 'liveCalls',
  Copilot: 'copilot',
  OpenClarity: 'open-clarity'
}
